import { render, staticRenderFns } from "./AudienceGroupSelector.vue?vue&type=template&id=a45f166c&scoped=true"
import script from "./AudienceGroupSelector.vue?vue&type=script&lang=js"
export * from "./AudienceGroupSelector.vue?vue&type=script&lang=js"
import style0 from "./AudienceGroupSelector.vue?vue&type=style&index=0&id=a45f166c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45f166c",
  null
  
)

export default component.exports